import apiClient from "./axios"

const BASE_URL = "/vehicle-stock"

export const getVehicleImageIds = async vehicleId => {
  const response = await apiClient.get(`${BASE_URL}/${vehicleId}/image-ids`)
  return response.data
}

export const getVehicleImageFile = async (vehicleId, imageId, imgType) => {
  const response = await apiClient.get(
    `${BASE_URL}/${vehicleId}/image/${imageId}`,
    {
      params: { imgType },
      responseType: "blob",
      skipToast: true,
    }
  )

  return new File(
    [response.data],
    `${vehicleId}-image-${imageId}.jpg`,
    {
      type: response.data.type,
    }
  )
}
